import { useMemo } from 'react'
import type { StatusMode } from './useProjectStatusMode'
import { useProjects } from '@/lib/db/rxdb/hooks/entities/projects'

/**
 * Returns a Map of projectId -> StatusMode for all projects.
 * Used by cross-project views (TaskList) to avoid N individual subscriptions.
 */
export function useProjectStatusModeMap(): {
  statusModeMap: Map<string, StatusMode>
  isLoading: boolean
} {
  const { projects, isLoading } = useProjects()

  const statusModeMap = useMemo(() => {
    const map = new Map<string, StatusMode>()
    if (projects) {
      for (const project of projects) {
        map.set(project.id, project.statusMode ?? 'simple')
      }
    }
    return map
  }, [projects])

  return { statusModeMap, isLoading }
}
